import Dialog from '@mui/material/Dialog'
import PropTypes from 'prop-types'
import React from 'react'

import Text from './text'

const Title = ({ children }) => (
  <Text variant="avenir24Bold" color="brand.color">
    {children}
  </Text>
)

Title.propTypes = {
  children: PropTypes.node.isRequired,
}

Dialog.Title = Title

export default Dialog
